module.exports = __webpack_public_path__ + "static/media/intro-pic.1bb2ce5e.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/intro-pic.jpg
// module id = 386
// module chunks = 0